export default __webpack_public_path__ + "Frame-eba8ca4bb6ef60c91169133710b8f0e8.svg";